function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M8.491 20c-3.638 0-8.475-.352-8.475-3.392 0-2.477 3.564-4.274 8.475-4.274s8.476 1.797 8.476 4.274c0 3.04-4.838 3.392-8.476 3.392zm0-6.166c-4.173 0-6.977 1.434-6.977 2.774 0 1.202 2.543 1.892 6.977 1.892s6.977-.69 6.977-1.892c0-1.34-2.804-2.774-6.977-2.774zm0-2.883c-2.795 0-5.068-2.277-5.068-5.077 0-2.798 2.273-5.075 5.068-5.075 2.795 0 5.068 2.277 5.068 5.075 0 2.8-2.273 5.077-5.068 5.077zm0-8.651c-1.969 0-3.57 1.603-3.57 3.574 0 1.973 1.601 3.576 3.57 3.576 1.969 0 3.57-1.603 3.57-3.576 0-1.971-1.601-3.574-3.57-3.574z"
});

var SvgMyProfile = function SvgMyProfile(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMyProfile, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/my_profile.d6f999db.svg";
export { ForwardRef as ReactComponent };